module.exports = __webpack_public_path__ + "img/index-providers.bff22a6.webp";